"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageProgramsScreen = void 0;
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const redux_1 = require("@/redux");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const subcomponents_1 = require("./subcomponents");
const tableColumns = [
    {
        Header: constants_1.default.managePrograms.tableColumnName,
        accessor: 'name',
        minWidth: 200,
        sortable: true,
        Cell: subcomponents_1.TableCells.LinkCell,
    },
];
const ManageProgramsScreen = ({ user, programs, pendingPrograms, getPrograms, }) => {
    const [search, setSearch] = react_1.useState('');
    const [initial, setInitial] = react_1.useState(true);
    react_1.useEffect(() => {
        if (user && user.id && !pendingPrograms) {
            getPrograms();
            setInitial(false);
        }
    }, [user]);
    const loadPrograms = react_1.useCallback(lodash_1.debounce((value) => {
        getPrograms({ search: value });
    }, 300), []);
    react_1.useEffect(() => {
        loadPrograms(search);
    }, [search]);
    const onChangeSearch = (e) => {
        const { value } = e.target;
        setSearch(value);
    };
    return (react_1.default.createElement("div", { className: styles_scss_1.default.managePrograms },
        react_1.default.createElement(components_1.Meta, { title: constants_1.default.managePrograms.helmetTitle, removeViewport: true }),
        react_1.default.createElement(components_1.Paper, { className: styles_scss_1.default.paperContainer },
            react_1.default.createElement("div", { className: styles_scss_1.default.header },
                react_1.default.createElement("h2", null, constants_1.default.managePrograms.title),
                react_1.default.createElement("div", { className: styles_scss_1.default.headerBar },
                    react_1.default.createElement(components_1.SearchInput, { name: "search", placeholder: constants_1.default.managePrograms.searchPlaceholder, onChange: onChangeSearch, value: search }),
                    react_1.default.createElement("div", { className: styles_scss_1.default.linkContainer },
                        react_1.default.createElement(components_1.Link, { to: constants_1.Routes.ManageProgramsCreate },
                            react_1.default.createElement(components_1.Button, { variant: "primary", ariaLabel: constants_1.default.managePrograms.addNewProgram, title: constants_1.default.managePrograms.addNewProgram }))))),
            react_1.default.createElement("div", { className: styles_scss_1.default.tableCont },
                react_1.default.createElement(components_1.Table, { columns: tableColumns, data: programs, loading: pendingPrograms && initial })))));
};
exports.ManageProgramsScreen = ManageProgramsScreen;
const stateProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
    programs: selectors_1.default.program.getAdminPrograms(state),
    pendingPrograms: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.listPrograms),
});
const dispatchProps = {
    getPrograms: (data) => redux_1.ActionCreators.program.listProgramsRequest.dispatch(data),
};
exports.default = react_redux_1.connect(stateProps, dispatchProps)(exports.ManageProgramsScreen);
